<template>
    <div></div>
</template>

<script>

    import {getRequest, postRequest, getBase64} from "../base/ApiService";

    export default {
        name: "ApiService",

        uploadCandidateFileS3(data, callback, error) {
            getBase64(data['file'], function(result){
                data['file'] = result;
                return postRequest('uploadCandidateFileS3', data).then(callback).catch(error)
            });
        },
        getSubscriptionForm(key) {
            return getRequest('getSubscriptionForm', {key: key})
        },
        getSubscriptionsList(queryParams) {
            return getRequest('getSubscriptionsList', null, queryParams)
        },
        getCandidateSubscriptionsList() {
            return getRequest('getCandidateSubscriptionsList')
        },
        postSubscriptionForm(data) {
            return postRequest('postSubscriptionForm', data)
        },
        getTotalSubscriptions(key) {
            return getRequest('getTotalSubscriptions', {key: key})
        },
        getSubscriptionsFile(data) {
            return postRequest('getSubscriptionsFile', data)
        },
        getClassificationFile(key) {
            return getRequest('getClassificationFile', {key: key})
        },
        postSubscriptionCancel(key) {
            return postRequest('cancelSubscription', {}, {key: key})
        },
        postSendEmail(data){
            return postRequest('postSendEmail', data)
        },
        getBackupFile(slug, pass) {
            return getRequest('getBackupFile', {slug: slug}, {admin_password: pass})
        },
        postReplacePayment(data){
            return postRequest('postReplacePayment', data)
        },
        cancelSubscriptions(data) {
            return postRequest('cancelSubscriptions', data)
        },
    }

</script>
